// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"437":"4596e82d","453":"63d7b31e"}[chunkId] + ".chunk.js";
};